<template>
  <div class="sign-up">
    <div class="content">
      <i class="el-icon-close flex-end fs-22 cursor gray" @click="close"></i>
      <h2 class="fs-24 marginB26">Check your email</h2>
      <div class="check-info">
        <span>We've sent you a six-digit confirmation code to</span>
        {{account}}.
        <span>Please enter it below to confirm your email address.</span>
      </div>
      <!-- 验证码输入框 -->
      <div class="code-wrap">
        <el-input
            class="code-paste"
            v-for="(item, index) in codeRefList"
            v-model="codeValue[index]"
            :key="index"
            maxlength="1"
            :min="0"
            :max="9"
            onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
            ref="codeRef"
            @input.native="(e) => changeCodeInput(e, index)"
            @keydown.native="(e) => keydownInput(e, index)"
        >
        </el-input>
      </div>
      <input
          ref="hideInput"
          style="width: 0; height: 0; opacity: 0; border: 0"/>
      <div
          class="verify-btn"
          @click="verifyRegister">Verify</div>
      <div class="ac light-grey fs-12 help-center cursor">
        <p>
        <span class="border" @click="sendCodeAgain">
          Send code again
        </span>
          <span class="marginL5">or find more</span>
        </p>
        <p>
        <span
            @click="toHelpCenter">information in</span>
        </p>
        <p>
        <span
            class="border"
            @click="toHelpCenter">Help Center.</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { gaAnalyze } from '@/assets/js/googleAnalyze/event.js';
export default {
  name: 'VerificationPage',
  data () {
    return {
      account: '',
      verifyCode: '',
      codeRefList: [null, null, null, null, null, null],
      codeValue: []
    }
  },
  created () {
    this.account = this.$store.state.email
    this.$nextTick(() => {
      this.$refs.codeRef[0].focus()
    })
  },
  mounted () {
    document.addEventListener('paste', (event) => {
      if (!event.path[1].className.includes('code-paste')) return
      // 获取解析 粘贴的文本
      let text = (event.clipboardData || window.clipboardData).getData('text')
      if (!this.checkNumber(text)) return
      if (text.length > 1 && text.length < 7) {
        this.codeValue = text.split('').map(Number)
      } else {
        this.codeValue = text.substring(0, 6).split('').map(Number)
      }
      this.$nextTick(() => {
        this.$refs.hideInput.focus()
      })
    })
  },
  methods: {
    close () {
      this.$router.push('/start')
    },
    keydownInput (e, index) {
      const contentVal = this.$refs.codeRef[index].value
      if ((contentVal === null || contentVal === '' || contentVal === undefined) && e.keyCode === 8) {
        const isDelFirst = index === 0
        if (!isDelFirst) {
          this.$refs.codeRef[index - 1].focus()
        }
      }
    },
    checkNumber (String) {
      var reg = /^[0-9]+.?[0-9]*$/
      if (reg.test(String)) {
        return true
      }
      return false
    },
    changeCodeInput (e, index) {
      if (e.inputType == 'deleteContentBackward') {
        const isDelFirst = index === 0
        if (!isDelFirst) {
          this.$refs.codeRef[index - 1].focus()
        }
      } else {
        e.target.value = e.target.value.replace(/[^\d.]/g, '')
        let val = e.target.value
        if (val === '' || !this.checkNumber(val)) return
        const isLast = index === this.codeRefList.length - 1
        const refValue = this.$refs.codeRef[index + 1]
        if (isLast) {
          return this.$refs.codeRef[index].blur()
        }
        refValue.focus()
      }
    },
    toHelpCenter () {
      window.open('https://www.figma.com/proto/bGs22XmuPdnoSX65Wh6hFo/LC-Hub-Concepts?node-id=277%3A12078&scaling=min-zoom&page-id=262%3A9230&starting-point-node-id=277%3A12078&show-proto-sidebar=1')
    },
    sendCodeAgain () {
      gaAnalyze('lpActiveSend');
      let params = {
        userId: this.$store.state.userId,
        service: 1
      }
      this.axios.post(
        '/userGroup/user-group/rgUser/sendVerifyCode', params).then((res) => {
          if(res.data.errorCode == '0x0'){
            this.$message.success('send success')
          }else{
            this.$message.error('send error')
          }
      }).catch()
    },
    verifyRegister () {
      gaAnalyze('lpActiveActive');
      this.verifyCode = this.codeValue.join('')
      if (!this.verifyCode) {
        return this.$message({
          message: 'Please enter verification code',
          type: 'error',
          duration: 3000
        })
      }
      let params = {
        userId: this.$store.state.userId,
        verifyCode: this.verifyCode,
        service: 1
      }
      this.axios.post(
          '/userGroup/user-group/rgUser/verify', params).then((res) => {
            if(res.data.errorCode == '0x0'){
              this.$message.success(res.data.errorInfo);
              let key = res.data.result;
              window.location.href = "https://" + window.location.host + '/userGroup/user-group/rgUser/redirectSuccess?service=1&userId=' + this.$store.state.userId + '&key=' + key;
            }else{
              this.$message.error(res.data.errorInfo);
            }
      }).catch(() => {
        this.isLoading = false
      })
    }
  },
  beforeDestroy () {
    document.removeEventListener('paste', () => {})
  }
}
</script>

<style lang="less" scoped>
.check-info {
  color: #585B5D;
  margin-top: 97px;
  margin-bottom: 50px;
  line-height: 24px;
  text-align: center;
}

.verify-btn {
  background: #33AB4F;
  border-radius: 8px;
  width: 117px;
  height: 39px;
  line-height: 39px;
  text-align: center;
  color: #ffffff;
  font-size: 13px;
  margin: 62px auto 70px;
  cursor: pointer;
}

.help-center {
  p {
    line-height: 18px;
  }
}

.code-wrap {
  display: flex;
  justify-content: center;
  /deep/ .el-input {
    width: 35px;
    margin-left: 8px;
  }

  /deep/.el-input__inner {
    width: 35px;
    height: 46px;
    line-height: 46px;
  }

  /deep/.el-input__inner {
    border: 1px solid #47A325BF
  }

  /deep/.el-input__inner {
    padding: 0;
    font-size: 16px;
    text-align: center;
  }
}

.code-content {
  padding: 20px 50px 0 58px;
}

</style>
